"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _buttons = require("@vds-core/buttons");
var _Button = _interopRequireDefault(require("./Button"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var propTypes = {
  /**
   * If provided, Button components will be rendered based on this data.
   * @typeName buttonData
   * @note The options 'secondary' and 'primary' are deprecated for prop 'type'
   */
  data: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    size: _propTypes["default"].oneOf(["small", "large"]),
    buttonType: _propTypes["default"].oneOf(["primary", "secondary", "textLink", "textLinkCaret"]),
    children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].string]),
    onClick: _propTypes["default"].func,
    disabled: _propTypes["default"].bool,
    surface: _propTypes["default"].oneOf(["light", "dark"]),
    href: _propTypes["default"].string,
    ariaLabel: _propTypes["default"].string,
    width: _propTypes["default"].string
  })),
  /**
   * Component will render in Inverted state.
   */
  inverted: _propTypes["default"].bool,
  /**
   * An object containing number of Button components per row, in each viewport
   */
  rowQuantity: _propTypes["default"].shape({
    mobile: _propTypes["default"].number,
    tablet: _propTypes["default"].number,
    desktop: _propTypes["default"].number
  }),
  /**
   * Viewport the Buttons will be rendered in
   */
  viewport: _propTypes["default"].oneOf(["desktop", "tablet", "mobile"])
};
var defaultProps = {
  inverted: false
};
var ButtonGroup = function ButtonGroup(props) {
  function _onClick(e, onClick) {
    if (e.detail !== 0) {
      onClick && onClick(e);
      e.target.blur();
    } else if (e.type === "click") {
      onClick && onClick(e);
    }
  }

  // NOTE props is returned from core, which takes buttonData's items
  function _renderButton(props) {
    var use = props.use,
      children = props.children,
      size = props.size,
      width = props.width,
      _onClick2 = props.onClick,
      ariaLabel = props.ariaLabel,
      surface = props.surface;
    if (use === "primary") {
      return /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({}, props, {
        primary: true,
        inverted: surface === "dark",
        style: {
          maxWidth: "100%"
        },
        ariaLabel: ariaLabel,
        children: children,
        size: size,
        width: size !== "small" && "100%",
        onClick: function onClick(e) {
          return _onClick(e, _onClick2);
        }
      }));
    } else if (use === "secondary") {
      return /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({}, props, {
        inverted: surface === "dark",
        secondary: true,
        style: {
          maxWidth: "100%"
        },
        ariaLabel: ariaLabel,
        children: children,
        size: size,
        width: size !== "small" && "100%",
        onClick: function onClick(e) {
          return _onClick(e, _onClick2);
        }
      }));
    }
  }
  var _calculateButtonSpacing = function _calculateButtonSpacing(size, buttonType) {
    var rightSpacing;
    var bottomSpacing;
    var isButton = buttonType === "primary" || buttonType === "secondary";
    switch (size) {
      case "large":
        rightSpacing = isButton ? "3X" : "6X";
        bottomSpacing = isButton ? "3X" : "4X";
        break;
      case "small":
        rightSpacing = isButton ? "2X" : "4X";
        bottomSpacing = isButton ? "4X" : "4X";
        break;
    }
    return {
      rightSpacing: rightSpacing,
      bottomSpacing: bottomSpacing
    };
  };
  var _getButtonWrapperWidth = function _getButtonWrapperWidth(size, width) {
    if (size === "small") {
      return "auto";
    } else return width;
  };
  var _calculateRowSpacing = function _calculateRowSpacing(rowData, nextRowData) {
    var size = rowData.length > 0 && rowData[0].size;
    return size === "small" ? "4X" : "3X";
  };

  /** Remapping data's buttonType or type (backwards compatibility) to 'use' to include the options for textLink or textLinkCaret used in marketing only. Not exposed to VDS users */
  var _getData = function _getData() {
    return props.data.map(function (buttonChild) {
      var isVDSButton = buttonChild.type !== undefined && (buttonChild.type === 'primary' || buttonChild.type === 'secondary' || buttonChild.type === 'textLink' || buttonChild.type === 'textLinkCaret');
      var childType = isVDSButton ? buttonChild.type : buttonChild.buttonType;
      return _objectSpread(_objectSpread({}, buttonChild), {}, {
        use: childType
      });
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_buttons.ButtonGroup, (0, _extends2["default"])({}, props, {
    data: _getData(),
    surface: props.inverted ? "dark" : "light",
    renderButton: _renderButton,
    maxWidth: "596px",
    calculateButtonSpacing: _calculateButtonSpacing,
    getButtonWrapperWidth: _getButtonWrapperWidth,
    calculateRowSpacing: _calculateRowSpacing
  }));
};
ButtonGroup.propTypes = propTypes;
ButtonGroup.defaultProps = defaultProps;
var _default = exports["default"] = ButtonGroup;


//////////////////
// WEBPACK FOOTER
// ./~/@vds/buttons/dist/cjs/components/ButtonGroup.js
// module id = 1403
// module chunks = 0